var _circle, _circle2, _g, _rect, _rect2, _rect3, _rect4, _g2, _rect5, _g3, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconEmail = function SvgIconEmail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 153,
    viewBox: "0 0 153 153",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 76.5,
    cy: 76.5,
    r: 76.5,
    fill: "url(#paint0_linear)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 153,
    height: 153
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.5,
    cy: 76.5,
    r: 76.5,
    fill: "url(#paint1_linear)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.211 130.569C148.038 130.847 147.864 131.123 147.691 131.397C147.193 131.791 146.604 132.001 146 132H53C52.4232 132.001 51.8587 131.809 51.3747 131.448C51.2141 131.204 51.0553 130.959 50.8947 130.713L51.0553 130.612L98.1359 100.6C98.5536 100.334 99.0231 100.194 99.5004 100.194C99.9778 100.193 100.448 100.331 100.866 100.596L148.052 130.468L148.211 130.569Z",
    fill: "#049BE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146 67.4626L105.197 40.3629C103.481 39.2231 101.534 38.6225 99.5521 38.6214C97.5703 38.6203 95.6231 39.2187 93.9059 40.3565L53 67.4626C52.2047 67.4639 51.4423 67.8278 50.8799 68.4746C50.3176 69.1213 50.0011 69.9981 50 70.9127V128.55C50.0009 129.465 50.3173 130.341 50.8797 130.988C51.4421 131.635 52.2046 131.999 53 132H146C146.795 131.998 147.558 131.634 148.12 130.988C148.682 130.341 148.999 129.464 149 128.55V70.9127C148.999 69.9981 148.682 69.1213 148.12 68.4746C147.558 67.8278 146.795 67.4639 146 67.4626ZM148.647 128.55C148.645 129.357 148.366 130.13 147.87 130.7C147.374 131.271 146.702 131.592 146 131.594H53C52.2983 131.593 51.6258 131.271 51.1296 130.701C50.6335 130.13 50.3542 129.357 50.3529 128.55V70.9127C50.3538 70.1057 50.633 69.3319 51.1292 68.7612C51.6254 68.1905 52.2982 67.8695 53 67.8685L93.9059 40.7624C95.6231 39.6246 97.5703 39.0262 99.5521 39.0273C101.534 39.0284 103.481 39.629 105.197 40.7688L146 67.8685C146.702 67.8695 147.375 68.1905 147.871 68.7612C148.367 69.3319 148.646 70.1057 148.647 70.9127V128.55Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5529 100.072C99.2455 100.073 98.9403 100.015 98.6501 99.8981L98.5967 99.8764L98.5859 99.7399C98.5526 99.7588 98.5191 99.7768 98.4854 99.7938L98.4499 99.8118L98.4144 99.7937C98.34 99.7562 98.2662 99.7137 98.1949 99.6675L65.7059 78.6719V35.8028C65.7069 34.8074 66.0511 33.853 66.6632 33.1492C67.2752 32.4453 68.105 32.0494 68.9706 32.0483H130.029C130.895 32.0494 131.725 32.4453 132.337 33.1492C132.949 33.853 133.293 34.8074 133.294 35.8028V78.7267L133.249 78.7558L100.911 99.6676C100.496 99.9337 100.028 100.073 99.5529 100.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5529 100.174C99.2356 100.175 98.9204 100.114 98.6208 99.9938L98.5139 99.9505L98.5094 99.8925L98.4499 99.9226L98.3789 99.8867C98.3019 99.8477 98.2255 99.8037 98.1517 99.7559L65.6176 78.7314V35.8028C65.6187 34.7805 65.9722 33.8003 66.6008 33.0775C67.2294 32.3546 68.0816 31.9479 68.9706 31.9468H130.029C130.918 31.9479 131.771 32.3546 132.399 33.0775C133.028 33.8003 133.381 34.7805 133.382 35.8028V78.7861L100.954 99.756C100.526 100.031 100.043 100.175 99.5529 100.174ZM98.8447 99.6508C99.4935 99.8651 100.19 99.7757 100.781 99.4021L133.029 78.5486V35.8028C133.029 34.8881 132.712 34.0111 132.15 33.3643C131.587 32.7175 130.825 32.3537 130.029 32.3527H68.9706C68.1752 32.3537 67.4127 32.7175 66.8503 33.3643C66.2878 34.0111 65.9715 34.8881 65.9706 35.8028V78.4937L68.0864 79.8603L98.3247 99.4022C98.3659 99.4289 98.4076 99.4539 98.45 99.4774C98.4924 99.4539 98.5341 99.4289 98.5752 99.4023L98.8128 99.2483L98.8447 99.6508Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.218 68.9604L135.412 77.2406L133.206 78.6674L100.868 99.5791C100.466 99.8368 100.013 99.9717 99.5529 99.9708C99.2556 99.9718 98.9602 99.9148 98.6795 99.8023C98.6013 99.7736 98.5247 99.7397 98.45 99.7009C98.3777 99.6643 98.3071 99.6237 98.2383 99.5791L68 80.0373L65.7941 78.6126L50.8083 68.9279C50.7675 68.901 50.7376 68.8568 50.7251 68.8047C50.7125 68.7527 50.7183 68.697 50.7412 68.6499C50.7642 68.6031 50.8024 68.5687 50.8473 68.5542C50.8923 68.5398 50.9405 68.5464 50.9812 68.5727L65.7941 78.1458L68 79.5705L98.4112 99.2239C98.5121 99.2891 98.6171 99.3454 98.7253 99.3924C98.7712 99.4127 98.8189 99.4309 98.8665 99.4472C99.1686 99.5538 99.4863 99.589 99.8005 99.5506C100.115 99.5122 100.419 99.4011 100.695 99.2239L133.206 78.2026L135.412 76.7759L148.045 68.6072C148.065 68.5942 148.088 68.5858 148.111 68.5826C148.134 68.5794 148.157 68.5815 148.179 68.5886C148.201 68.5958 148.222 68.6079 148.241 68.6244C148.259 68.6408 148.274 68.6612 148.285 68.6844C148.297 68.7076 148.304 68.7331 148.307 68.7595C148.309 68.7859 148.308 68.8127 148.301 68.8383C148.295 68.864 148.285 68.8879 148.27 68.9089C148.256 68.9298 148.238 68.9473 148.218 68.9604Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9543 45.3413H74.0132C73.6387 45.3413 73.2797 45.1703 73.0149 44.8658C72.7501 44.5613 72.6014 44.1483 72.6014 43.7177C72.6014 43.2871 72.7501 42.8742 73.0149 42.5697C73.2797 42.2652 73.6387 42.0942 74.0132 42.0942H78.9543C79.3288 42.0942 79.6879 42.2652 79.9526 42.5697C80.2174 42.8742 80.3661 43.2871 80.3661 43.7177C80.3661 44.1483 80.2174 44.5613 79.9526 44.8658C79.6879 45.1703 79.3288 45.3413 78.9543 45.3413Z",
    fill: "#049BE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7779 50.8209H74.0132C73.6387 50.8209 73.2797 50.6499 73.0149 50.3454C72.7501 50.0409 72.6014 49.6279 72.6014 49.1973C72.6014 48.7667 72.7501 48.3538 73.0149 48.0493C73.2797 47.7448 73.6387 47.5737 74.0132 47.5737H84.7779C85.1523 47.5737 85.5114 47.7448 85.7761 48.0493C86.0409 48.3538 86.1897 48.7667 86.1897 49.1973C86.1897 49.6279 86.0409 50.0409 85.7761 50.3454C85.5114 50.6499 85.1523 50.8209 84.7779 50.8209Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.853 65.4331H84.3235C83.9491 65.4331 83.59 65.2621 83.3253 64.9576C83.0605 64.6531 82.9118 64.2402 82.9118 63.8096C82.9118 63.379 83.0605 62.966 83.3253 62.6615C83.59 62.357 83.9491 62.186 84.3235 62.186H114.853C115.227 62.186 115.586 62.357 115.851 62.6615C116.116 62.966 116.265 63.379 116.265 63.8096C116.265 64.2402 116.116 64.6531 115.851 64.9576C115.586 65.2621 115.227 65.4331 114.853 65.4331Z",
    fill: "#049BE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.676 71.7245H81.3235C80.9491 71.7245 80.59 71.5535 80.3253 71.249C80.0605 70.9445 79.9118 70.5315 79.9118 70.1009C79.9118 69.6703 80.0605 69.2574 80.3253 68.9529C80.59 68.6484 80.9491 68.4774 81.3235 68.4774H117.676C118.051 68.4774 118.41 68.6484 118.675 68.9529C118.939 69.2574 119.088 69.6703 119.088 70.1009C119.088 70.5315 118.939 70.9445 118.675 71.249C118.41 71.5535 118.051 71.7245 117.676 71.7245Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.676 77.813H81.3235C80.9491 77.813 80.59 77.6419 80.3253 77.3374C80.0605 77.0329 79.9118 76.62 79.9118 76.1894C79.9118 75.7588 80.0605 75.3458 80.3253 75.0413C80.59 74.7368 80.9491 74.5658 81.3235 74.5658H117.676C118.051 74.5658 118.41 74.7368 118.675 75.0413C118.939 75.3458 119.088 75.7588 119.088 76.1894C119.088 76.62 118.939 77.0329 118.675 77.3374C118.41 77.6419 118.051 77.813 117.676 77.813Z",
    fill: "#E6E6E6"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 74,
    width: 13,
    height: 4,
    rx: 2,
    fill: "#24A8E8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 85,
    width: 33,
    height: 4,
    rx: 2,
    fill: "#049BE5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 97,
    width: 33,
    height: 4,
    rx: 2,
    fill: "#049BE5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 109,
    width: 26,
    height: 4
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 109,
    width: 26,
    height: 4,
    fill: "#049BE5"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 109,
    width: 33,
    height: 4,
    rx: 2,
    fill: "#049BE5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 121,
    width: 10,
    height: 4
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 121,
    width: 10,
    height: 4,
    fill: "#049BE5"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 121,
    width: 12,
    height: 4,
    rx: 2,
    fill: "#049BE5"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 146,
    y1: 109.5,
    x2: 7,
    y2: 43.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BAD8EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 146,
    y1: 109.5,
    x2: 7,
    y2: 43.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BAD8EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3FBFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 99,
    height: 100.053,
    fill: "white",
    transform: "translate(50 31.9468)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconEmail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-email.e5cf48ec.svg";
export { ForwardRef as ReactComponent };